import { client } from "api";

export type DeleteCustomerReferenceRequest = { orderId: string };

export const deleteCustomerReference = ({ orderId }: DeleteCustomerReferenceRequest) =>
  client.delete<void>(`/order/${orderId}/customer-reference`).then((res) => res.data);
